<script setup lang="ts">
defineProps<{ data: FormProps; template?: 'page' | 'overlay' }>()
const success = ref<boolean>(false)
</script>

<template>
  <Transition name="fade" mode="out-in">
    <div v-if="!success" :class="data.theme === 'light-grey' ? 'bg-light-grey' : ''">
      <FormsContact v-if="data.type === 'contact'" @success="success = true" />
      <FormsOnlineDemo v-if="data.type === 'online-demo'" @success="success = true" />
      <FormsLabVisit v-if="data.type === 'lab-visit'" @success="success = true" />
    </div>
    <div v-else class="success px-bleed">
      <h2
        class="font-display max-w-[calc(100%-var(--grid-bleed)*2-3.5rem)] pt-11 text-2xl uppercase font-stretch-expanded lg:pt-16 lg:text-4xl"
      >
        Thank you
      </h2>

      <p class="pt-5 text-lg">We have received your request. We’ll be in touch soon!</p>
    </div></Transition
  >
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
